"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boundarySection = void 0;
const types_1 = require("../../../types");
exports.boundarySection = {
    label: "form.boundary.label",
    name: "boundary",
    subline: "form.boundary.subline",
    fields: [
        {
            name: "weight",
            label: "form.boundary.weight",
            type: types_1.FormFieldType.short,
        },
        {
            name: "height",
            label: "form.boundary.height",
            type: types_1.FormFieldType.short,
        },
        {
            name: "width",
            label: "form.boundary.width",
            type: types_1.FormFieldType.short,
        },
        {
            name: "usage",
            label: "form.boundary.usage",
            type: types_1.FormFieldType.area,
        },
    ],
};
exports.default = exports.boundarySection;
